/* eslint-disable indent */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/**
 *
 * Settlements
 *
 */

import React, {
  memo,
  useState,
  useEffect,
  useContext,
  useReducer,
  useRef,
} from 'react';
import {
  useNavigate,
  useSearchParams,
  useLocation,
  Link,
} from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { createStructuredSelector } from 'reselect';
import { compose } from 'redux';
import moment from 'moment';

import {
  Popup,
  Conditional,
  Text,
  Toggle,
  Space,
  Tab,
  Icon,
} from '@cashfree-intl/coherent';
import { usePermissionCode } from '@cashfree-intl/auth';

import { MerchantDetailsContext } from 'contexts/MerchantDetailsContext';
import WithReadPermissions from 'components/WithReadPermission';

import { useInjectSaga } from 'utils/injectSaga';
import { useInjectReducer } from 'utils/injectReducer';

import {
  roundOffNumber,
  addCurrencySymbol,
  getItemFromLocalStorage,
  setItemsInLocalStorage,
  copyToClipboard,
  titleCase,
  formatLargeNumber,
  convertToTimezone,
  // updateHeaderWithTimezone,
} from 'utils/common';
import {
  TX_STATUS_CLASSNAME,
  DEFAULT_CURRENT_PAGE,
  STANDARD,
  INSTANT,
  VENDOR,
  DEFAULT_LIMIT_OPTIONS,
  SETTLEMENT_NORMAL_DAY_URL,
  SETTLEMENT_HOLIDAY_URL,
  HOLD,
  ON_DEMAND,
  DATE_AND_TIME_FORMAT,
  ANNOUNCEMENT_STRIP_DATA,
  PLACEHOLDER_TEXT,
  ON_DEMAND_SETTLEMENT_STATUS_MAPPER,
  TIME_FORMATS,
  NOT_APPLICABLE,
  NAVIGATION_BAR_OPTIONS,
  CURRENCY_SYMBOL,
  IMPORT_TRANSACTIONS,
} from 'utils/constants';
import { get, keyBy } from 'lodash';
import { MerchantContext } from 'contexts/MerchantContext';
import { getTableConfig } from 'pageConfig';

import PaginatedTable from 'components/PaginatedTable';
import { formatColumns } from 'components/PaginatedTable/helpers';

import { PERM_CODES } from 'constants/permCodes';
import EVENTS from '../../constants/analytics';
import Analytics from '../../utils/analytics';

import Loader from '../../components/Loader';
import CustomIcon from '../../components/CustomIcons';
import AnnouncementStrip from '../../components/AnnouncementStrip/Loadable';
import makeSelectSettlements from './selectors';
import reducer, { liveSettlementReducer } from './reducer';
import saga from './saga';
import onDemandSettlementsSaga from '../OnDemandSettlements/saga';

import {
  enableLoaderAction,
  updateTableDataAction,
  searchSettlementsAction,
  searchImportSettlementsAction,
  updateFiltersAction,
  resetFiltersAction,
  generateSettlementReportAction,
  resetPageAction,
  getSettlementsHolidaysAction,
  resetDataAction,
  getUnsettledAmountAction,
  getUnificationOnBoardingAction,
  getInstantSettlementsEligibilityAction,
  requestInstantSettlementsOnboardingAction,
  getOnDemandSettlementStatusAction,
  getInstantSettlementsMaxDailyLimit as getInstantSettlementsMaxDailyLimitAction,
  getInstantSettlementsRatesAndLimits as getInstantSettlementsRatesAndLimitsAction,
  getSettlementTimelineAction,
  setSettlementDetailsDataAction,
  resetSettlementTypeAction,
  getNextSettlementsDetailsAction,
  getUpcomingHolidaysAction,
} from './actions';
import { getOnDemandSettlementStatusAction as getOnDemandSettlementAndFreeTrialStatusAction } from '../OnDemandSettlements/actions';
import {
  INSTANT_SETTLEMENT,
  NOT_REQUESTED,
  INSTANT_SETTLEMENTS_ELIGIBILITY_STATUS,
  FETCH_LIVE_SETTLEMENT,
  SAVE_LIVE_SETTLEMENT,
  SETTLEMENT_STATUS_TYPES,
  VENDOR_SETTLEMENT_STATUS_TYPES,
  SETTLEMENTS_TYPES,
  IMPORT_SETTLEMENTS_STATUS,
  DISABLED_ICON_COLOR,
} from './constants';
import {
  NOT_REQUESTED as NOT_REQUESTED_ON_DEMAND,
  ACTIVE,
} from '../OnDemandSettlements/constants';

import DashboardFilters from '../DashboardFilters';
import OnDemandSettlements from '../OnDemandSettlements';

import { resetTwoFactorAuthentication as resetTwoFactorAuthenticationValue } from '../Toast/actions';
import { twoFactorAuthenticationSelector } from '../Toast/selectors';
import InstantSettlementsPitchPage from './components/InstantSettlementsPitchPage';
import UnsettledAmountCard from './components/UnsettledAmountCard';
import NextSettlementsAmountCard from './components/NextSettlementsAmountCard';
import FAQ_MODAL from './components/FAQModal';
import ConfigureInstantSettlements from './components/ConfigureInstantSettlements';
import InstantSettlementsActivationModal from './components/InstantSettlementsActivationModal';
import InstantSettlementsActivationBanner from './components/InstantSettlementsActivationBanner';

import { getOnDemandStatus } from '../OnDemandSettlements/util';
import StepProgress from './components/StepProgress';
import liveTag from '../../images/live-tag.svg';

import {
  formatDateToDateTimeFormat,
  getSmartReconEventLabel,
  sortSettlementComponentsList,
  updateHeadersWithTimezone,
} from './utils';
import { selectMerchantDetailsSelector } from '../DashboardContainer/selectors';

export const showInstantSettlementsStatusBanner = time =>
  moment().diff(
    moment(time)
      .clone()
      .add(3, 'days'),
  ) < 0;

const getSettlementStatusTitle = status => {
  if (status === SETTLEMENT_STATUS_TYPES.PENDING) {
    return 'In Progress';
  }
  return titleCase(status);
};
const getVenodorSettlementStatusTitle = status => {
  if (
    status === VENDOR_SETTLEMENT_STATUS_TYPES.PENDING ||
    status === VENDOR_SETTLEMENT_STATUS_TYPES.CREATED
  ) {
    return 'In Progress';
  }
  return titleCase(status);
};

// Settlements is used as a federated modules
export function Settlements({
  isModuleFederated = false,
  settlements,
  searchSettlements,
  searchImportSettlements,
  enableLoader,
  updateTableData,
  updateFilters,
  merchantDetails,
  resetPage,
  resetFilters,
  twoFactorAuthentication,
  resetTwoFactorAuthentication,
  menuSelected,
  getSettlementsHolidays,
  resetSettlementHolidays,
  activeNavigation: currentNavigation,
  resetData,
  getUnsettledAmount,
  getOnDemandSettlementStatus,
  getInstantSettlementsEligibility,
  requestInstantSettlementsOnboarding,
  getInstantSettlementsMaxDailyLimit,
  getInstantSettlementsRatesAndLimits,
  getOnDemandSettlementAndFreeTrialStatus,
  getSettlementTimeline,
  setSettlementDetailsData,
  resetSettlementType,
  getNextSettlementsDetails,
  getUpcomingHolidays,
}) {
  useInjectReducer({ key: 'settlements', reducer });
  useInjectSaga({ key: 'settlements', saga });
  useInjectSaga({ key: 'onDemandSettlements', saga: onDemandSettlementsSaga });
  const { settlementTabType } = settlements;

  const {
    isOnDemandEligible,
    showInstantTab,
    productStatus,
    easySplitEnabled,
    isMerchantImportEnabled,
    selectedTimeZone,
  } = useContext(MerchantContext);
  const { merchantDetails: userDetails } = useContext(MerchantDetailsContext);
  const hasPermission = isModuleFederated
    ? true
    : // eslint-disable-next-line react-hooks/rules-of-hooks
      usePermissionCode(PERM_CODES.PG_SETTLEMENTS_VIEW);

  const eposActivated = productStatus.EPOS === 'APPROVED';

  const ALERT_BAR_DATA = ANNOUNCEMENT_STRIP_DATA[menuSelected];

  const {
    isLoading,
    tabs,
    holidaysData,
    unSettledAmountData,
    nextSettlementsDetails,
    upcomingHolidays,
  } = settlements;

  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const [openModal, resetModal] = useState('');
  const [holidaysAlert, resetHolidaysAlert] = useState({});
  const [showHolidaysAlertBar, resetHolidaysAlertBar] = useState(
    !getItemFromLocalStorage(ALERT_BAR_DATA?.HOLIDAYS_ALERT.localStorageKey),
  );
  const [unSettledAmountLoader, resetUnsettledAmountLoader] = useState(false);
  const [onDemandStatus, resetOnDemandStatus] = useState('');
  const [instantSettlementsStatus, setInstantSettlementsStatus] = useState({});
  const [
    showInstantSettlementsPitchBanner,
    setInstantSettlementsPitchBannerDisplay,
  ] = useState(false);
  const [
    showInstantSettlementsActivationAlert,
    setInstantSettlementsActivationAlertDisplay,
  ] = useState(false);
  const [instantSettlementsConfig, setInstantSettlementsConfig] = useState({});
  const [
    instantSettlementsDailyLimit,
    setInstantSettlementsDailyLimit,
  ] = useState({});
  const [isISDailyLimitLoading, setISDailyLimitLoading] = useState(false);
  const [showFreeTrialTag, setShowFreeTrialTag] = useState(false);
  const [liveSettlementState, setLiveSettlementState] = useReducer(
    liveSettlementReducer,
    { settlementList: {}, loading: false },
  );

  const [activeNavigation, setActiveNavigation] = useState(currentNavigation);
  const isNavigatingToSettlementDetailsPage = useRef(false);

  // redirect the merchant to default tab if the current tab is not to be shown
  if (activeNavigation === INSTANT && !showInstantTab && !isModuleFederated) {
    navigate(`${location.pathname}`);
  }

  const { pathname } = location;

  const { env = '' } = Object.fromEntries(searchParams);

  const settlementType = SETTLEMENTS_TYPES.find(type =>
    pathname.includes(type),
  );

  useEffect(() => {
    const type = SETTLEMENTS_TYPES.find(settlementPathType =>
      pathname.includes(settlementPathType),
    );
    if (type !== settlementTabType) {
      resetFilters(activeNavigation);
      resetPage(activeNavigation);
      resetSettlementType({ type });
    }
  }, [pathname]);

  useEffect(() => {
    const matchedParams = pathname.split('/')[5] || pathname.split('/')[4];

    const mapper = {
      standard: 'Standard',
      vendor: 'Vendor',
      instant: 'Instant',
      'on-demand': 'On-Demand',
      online: 'Standard',
      offline: 'Standard',
    };
    // unrecognised path segments (e.g. /settlements/s) fall back to the
    // default tab instead of leaving activeNavigation undefined
    setActiveNavigation(mapper[matchedParams] || mapper.standard);
  });
  // redirect the merchant to default tab if the current tab is not to be shown
  if (activeNavigation === INSTANT && !showInstantTab && !isModuleFederated) {
    navigate(`${location.pathname}`);
  }
  const merchantLogo = get(merchantDetails, 'logoLarge', '');

  const {
    filters = {},
    filtersForDisplay = [],
    hasPrev = false,
    hasNext = false,
    currentPageRowData = [],
    data = [],
    pagination = {},
  } = tabs[activeNavigation] || tabs[STANDARD] || {};

  const getTableData = (f = filters) => {
    // make api call
    enableLoader();
    const { appliedFilters, pageNo, pageSize, includeSkipSettlements } = f;

    const formattedFilterObj = {
      ...appliedFilters,
      pageNo: pageNo - 1,
      pageSize,
      includeSkipSettlements: !!includeSkipSettlements,
    };

    if (
      appliedFilters.search &&
      appliedFilters.search.type &&
      appliedFilters.search.value &&
      appliedFilters.search.value.trim()
    ) {
      const {
        search: { type, value },
      } = appliedFilters;
      formattedFilterObj[type] = value.trim();
      delete formattedFilterObj.search;
    }

    if (isMerchantImportEnabled) {
      searchImportSettlements({
        activeNavigation,
        options: formattedFilterObj,
      });
    } else {
      searchSettlements({
        activeNavigation,
        options: formattedFilterObj,
        isModuleFederated,
        cb: searchSettlementCallback,
        settlementType,
      });
    }
  };

  // eslint-disable-next-line no-shadow
  const searchSettlementCallback = ({ data, activeNavigation }) => {
    if (activeNavigation === STANDARD || activeNavigation === VENDOR) {
      // const {
      //   merchantPayments: { content: settlementsList },
      // } = data;
      let settlementsList;
      let settlementId;
      let status;

      if (activeNavigation === VENDOR) {
        settlementsList = data.content;
        settlementId = 'payoutId';
        status = [
          VENDOR_SETTLEMENT_STATUS_TYPES.CREATED,
          VENDOR_SETTLEMENT_STATUS_TYPES.PENDING,
        ];
      } else {
        settlementsList = data.merchantPayments.content;
        settlementId = 'settlementId';
        status = [SETTLEMENT_STATUS_TYPES.PENDING];
      }

      const inProgressSettlements = settlementsList
        .filter(settlement => status.includes(settlement.status))
        .map(settlement => settlement[settlementId]);

      if (inProgressSettlements?.length) {
        setLiveSettlementState({ type: FETCH_LIVE_SETTLEMENT });
        getSettlementTimeline({
          inProgressSettlements,
          cb: getSettlementTimelineCallback,
          activeNavigation,
          settlementType,
        });
      }
    }
  };

  const getSettlementTimelineCallback = response => {
    if (response.error) {
      setLiveSettlementState({ type: SAVE_LIVE_SETTLEMENT, data: {} });
      return;
    }
    const dataKeyedBySettlementId = keyBy(response, 'settlementId');
    setLiveSettlementState({
      type: SAVE_LIVE_SETTLEMENT,
      data: dataKeyedBySettlementId,
    });
  };

  const onPageChange = type => {
    const options = { ...filters, activeNavigation };
    switch (type) {
      case 'NEXT':
        options.pageNo += 1;
        break;
      case 'PREV':
        options.pageNo -= 1;
        break;
      default:
        break;
    }
    updateFilters(options);
  };

  const onSkipToggleChange = () => {
    const options = { ...filters, activeNavigation };
    options.includeSkipSettlements = !filters.includeSkipSettlements;
    Analytics.track(
      EVENTS.SETTLEMENTS[activeNavigation].VIEW_SKIPPED_SETTLEMENTS,
      {
        includeSkipSettlements: !filters.includeSkipSettlements,
      },
    );
    updateFilters(options);
  };

  const onLimitChange = (e, limitChangeData) => {
    const options = {
      ...filters,
      pageNo: DEFAULT_CURRENT_PAGE,
      pageSize: parseInt(limitChangeData.value, 10),
      activeNavigation,
    };
    updateFilters(options);
    Analytics.track(EVENTS.SETTLEMENTS[activeNavigation].PAGE_SIZE, {
      pageSize: limitChangeData.value,
    });
  };

  useEffect(() => {
    if (!isLoading && data) {
      let totalCount = data.length;
      const pageData = JSON.parse(JSON.stringify(data));

      let formattedData = [];

      switch (activeNavigation) {
        case STANDARD: {
          formattedData = pageData.map(rowData => {
            const showRemarksForStatus =
              [
                SETTLEMENT_STATUS_TYPES.PROCESSED,
                SETTLEMENT_STATUS_TYPES.SKIPPED,
                SETTLEMENT_STATUS_TYPES.FAILED,
              ].includes(rowData.status) &&
              (!rowData.settledAmount || rowData.partialSettlement) &&
              rowData.remarks;
            const showRemarksForImportSettlementStatus =
              [SETTLEMENT_STATUS_TYPES.SKIPPED].includes(rowData.status) &&
              rowData.remarks;
            return {
              ...rowData,
              unFormattedData: rowData,
              id: rowData.settlementId,
              settlementTypeCTA: () => (
                <>
                  <Conditional
                    if={rowData.status === SETTLEMENT_STATUS_TYPES.PENDING}
                  >
                    <img
                      src={liveTag}
                      alt="live settlement"
                      className="live-tag-fixed"
                    />
                  </Conditional>
                  <Conditional
                    if={rowData.settlementType === INSTANT_SETTLEMENT}
                  >
                    <CustomIcon
                      componentName="LIGHTNING"
                      className="ml-2"
                      dimension="18px"
                    />
                  </Conditional>
                </>
              ),
              addedOn: () => (
                <div className="flex">
                  <span className="table-content">
                    {moment(rowData.addedOn).format('DD MMM YYYY,')}
                    <br />
                    {moment(rowData.addedOn).format('hh:mm A')}
                  </span>
                </div>
              ),
              period: () => (
                <div className="flex">
                  <span className="table-content">
                    {moment(rowData.periodStart).format('Do MMM YYYY, hh:mm A')}{' '}
                    - <br />
                    {moment(rowData.periodEnd).format('Do MMM YYYY, hh:mm A')}
                  </span>
                </div>
              ),
              utr: () => (
                <div className="flex copy-to-clipboard-wrapper">
                  <span className="table-content">{rowData.utr}</span>
                  {rowData.utr && rowData.utr !== 'N/A' ? (
                    <CustomIcon
                      componentName="COPY_TO_CLIPBOARD"
                      handleClick={e => {
                        Analytics.track(
                          EVENTS.SETTLEMENTS[activeNavigation].UTR_COPIED,
                        );
                        copyToClipboard(rowData.utr)(e);
                      }}
                    />
                  ) : (
                    PLACEHOLDER_TEXT
                  )}
                </div>
              ),
              settlementStatus: () => (
                <span
                  className={`${TX_STATUS_CLASSNAME[rowData.status] || ''}`}
                >
                  {!showRemarksForStatus ? (
                    getSettlementStatusTitle(rowData.status)
                  ) : (
                    <Popup
                      content={rowData.remarks}
                      trigger={
                        <span>
                          {getSettlementStatusTitle(rowData.status)}
                          <span className="mr-left-4 small-svg">
                            <CustomIcon
                              componentName="INFO"
                              fill={
                                rowData.status ===
                                SETTLEMENT_STATUS_TYPES.SKIPPED
                                  ? 'var(--SECONDARY_LIGHT)'
                                  : 'var(--SUCCESS_STATUS)'
                              }
                            />
                          </span>
                        </span>
                      }
                      position="bottom center"
                    />
                  )}
                  <Conditional
                    if={rowData.status === SETTLEMENT_STATUS_TYPES.PENDING}
                  >
                    <Conditional if={liveSettlementState.loading}>
                      <div className="ui active mini inline loader mr-left-4" />
                    </Conditional>
                    <Conditional
                      if={
                        !liveSettlementState.loading &&
                        liveSettlementState.settlementList[rowData.settlementId]
                      }
                    >
                      <Conditional
                        if={
                          !liveSettlementState.settlementList[
                            rowData.settlementId
                          ]?.isDelayed
                        }
                      >
                        <Text
                          variant="b12"
                          color="bodyLight"
                          className="font-normal mr-left-7 display-inline"
                        >
                          Expected Credit Time :{' '}
                          {formatDateToDateTimeFormat(
                            liveSettlementState.settlementList[
                              rowData.settlementId
                            ]?.estimatedTimeToArrival,
                            TIME_FORMATS.DATE_MONTH_YEAR_WITH_TIME,
                          )}
                        </Text>
                      </Conditional>
                      <StepProgress
                        merchantLogo={merchantLogo}
                        settlementData={
                          liveSettlementState.settlementList[
                            rowData.settlementId
                          ]
                        }
                      />
                    </Conditional>
                  </Conditional>
                </span>
              ),
              settledAmount: () => (
                <span>
                  <Conditional
                    if={rowData.status === SETTLEMENT_STATUS_TYPES.SKIPPED}
                  >
                    {isMerchantImportEnabled
                      ? PLACEHOLDER_TEXT
                      : NOT_APPLICABLE}
                  </Conditional>
                  <Conditional
                    if={rowData.status !== SETTLEMENT_STATUS_TYPES.SKIPPED}
                  >
                    {addCurrencySymbol(
                      roundOffNumber(rowData.settledAmount),
                    ) /* eslint-disable-line prettier/prettier */}
                  </Conditional>
                  <Conditional
                    if={
                      rowData.settlementDetailedView?.settlementComponentsList
                        ?.length &&
                      ![
                        VENDOR_SETTLEMENT_STATUS_TYPES.FAILED,
                        VENDOR_SETTLEMENT_STATUS_TYPES.PENDING,
                        VENDOR_SETTLEMENT_STATUS_TYPES.CREATED,
                        VENDOR_SETTLEMENT_STATUS_TYPES.REVERSED,
                      ].includes(rowData.status)
                    }
                  >
                    <div className="small-svg">
                      <Popup
                        trigger={
                          <span>
                            <Text
                              color="info"
                              variant="b12"
                              className="smart-recon-text small-text"
                            >
                              Smart recon{' '}
                            </Text>
                            <span>
                              <CustomIcon
                                componentName="INFO"
                                fill="var(--INFO)"
                              />
                            </span>
                          </span>
                        }
                        position="bottom center"
                        hoverable
                      >
                        <div className="pd-12 smart-recon-table">
                          {sortSettlementComponentsList(
                            rowData.settlementDetailedView
                              ?.settlementComponentsList,
                          ).map(breakDownDetails => {
                            const {
                              event,
                              eventType,
                              amount,
                            } = breakDownDetails;
                            const label = getSmartReconEventLabel(event);

                            return (
                              <>
                                <Space
                                  justifyContent="space-between"
                                  alignItems="center"
                                  key={event}
                                  className="mr-top-12 mr-btm-12"
                                >
                                  <Text
                                    color="bodyLight"
                                    variant="b12"
                                    className="font-normal"
                                  >
                                    {label}
                                  </Text>
                                  <Text
                                    color={
                                      eventType === 'DEBIT'
                                        ? 'danger'
                                        : 'success'
                                    }
                                    variant="b14"
                                  >
                                    {addCurrencySymbol(roundOffNumber(amount))}
                                  </Text>
                                </Space>
                                <hr />
                              </>
                            );
                          })}
                          <Text
                            variant="b12"
                            className="font-normal tiny-text line-ht-12"
                          >
                            Service charge and tax will be levied based on your
                            usage and plan type (postpaid/ prepaid). Check the{' '}
                            <Link
                              href={`${
                                location.pathname
                              }/settlement-details?settlementId=${
                                rowData.settlementId
                              }${env ? `&env=${env}` : ''}`}
                            >
                              {' '}
                              View Details
                            </Link>{' '}
                            section to know the detailed breakup.
                          </Text>
                        </div>
                      </Popup>
                    </div>
                  </Conditional>
                </span>
              ),
              initiatedOn: () => (
                <>
                  <Text color="bodyLight" className="font-normal">
                    {convertToTimezone(
                      rowData?.initiatedOn,
                      selectedTimeZone,
                      DATE_AND_TIME_FORMAT,
                    )}
                  </Text>
                </>
              ),
              transactionPeriod: () => (
                <>
                  <Text color="bodyLight" className="font-normal">
                    {convertToTimezone(
                      rowData?.txnPeriodFrom,
                      selectedTimeZone,
                      DATE_AND_TIME_FORMAT,
                    )}
                  </Text>
                  <Text color="bodyLight" className="font-normal">
                    {convertToTimezone(
                      rowData?.txnPeriodTo,
                      selectedTimeZone,
                      DATE_AND_TIME_FORMAT,
                    )}
                  </Text>
                </>
              ),
              netSettledAmount: () => (
                <Text color="bodyLight" className="font-normal">
                  <Conditional if={rowData?.netSettledAmount}>
                    {CURRENCY_SYMBOL.INR}{' '}
                    {formatLargeNumber(rowData?.netSettledAmount)}
                  </Conditional>
                  <Conditional if={!rowData?.netSettledAmount}>
                    {PLACEHOLDER_TEXT}
                  </Conditional>
                </Text>
              ),
              fcyAmount: () => (
                <Text color="bodyLight" variant="b14">
                  <Conditional if={rowData?.fcyAmount}>
                    {CURRENCY_SYMBOL[(rowData?.fcy)]}{' '}
                    {formatLargeNumber(rowData?.fcyAmount)}
                  </Conditional>
                  <Conditional if={!rowData?.fcyAmount}>
                    {PLACEHOLDER_TEXT}
                  </Conditional>
                </Text>
              ),
              fxRateFinal: () => (
                <Text color="bodyLight" variant="b14">
                  <Conditional if={rowData?.fxRateFinal}>
                    {rowData?.fxRateFinal}
                  </Conditional>
                  <Conditional if={!rowData?.fcyAmount}>
                    {PLACEHOLDER_TEXT}
                  </Conditional>
                </Text>
              ),
              importSettlementStatus: () => {
                const updatedStatus =
                  IMPORT_SETTLEMENTS_STATUS[(rowData?.status)];
                return (
                  <span
                    className={`w-600 ${TX_STATUS_CLASSNAME[
                      (rowData?.status)
                    ] || ''}`}
                  >
                    <Conditional if={!showRemarksForImportSettlementStatus}>
                      {updatedStatus}
                    </Conditional>
                    <Conditional if={showRemarksForImportSettlementStatus}>
                      <Popup
                        content={rowData.remarks}
                        trigger={
                          <span>
                            {updatedStatus}
                            <span className="mr-left-4 small-svg">
                              <CustomIcon
                                componentName="INFO"
                                fill="var(--SECONDARY_LIGHT)"
                              />
                            </span>
                          </span>
                        }
                        position="bottom center"
                      />
                    </Conditional>
                  </span>
                );
              },
              downloadCta: () => (
                <>
                  <Conditional if={rowData?.swiftFileUrl}>
                    <a
                      href={rowData.swiftFileUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      onClick={e => e.stopPropagation()}
                    >
                      <Icon name="download" width={16} height={16} />
                    </a>
                  </Conditional>
                  <Conditional if={!rowData?.swiftFileUrl}>
                    <Icon
                      name="download"
                      width={16}
                      height={16}
                      fill={DISABLED_ICON_COLOR}
                    />
                  </Conditional>
                </>
              ),
            };
          });
          break;
        }
        case INSTANT: {
          formattedData = pageData.map(rowData => ({
            ...rowData,
            addedOn: moment(rowData.addedOn).isValid()
              ? moment(rowData.addedOn).format(DATE_AND_TIME_FORMAT)
              : '',
            settlementId: () => (
              <div className="flex copy-to-clipboard-wrapper">
                <span className="table-content">{rowData.id}</span>
                {rowData.id && rowData.id !== 'N/A' ? (
                  <CustomIcon
                    componentName="COPY_TO_CLIPBOARD"
                    handleClick={copyToClipboard(rowData.id)}
                  />
                ) : (
                  ''
                )}
              </div>
            ),
            settlementStatus: () => (
              <span
                className={`w-600 ${TX_STATUS_CLASSNAME[
                  rowData.settlementStatus
                ] || ''}`}
              >
                {titleCase(rowData.settlementStatus)}
              </span>
            ),
            // settlementLinkCTA: () => (
            //   <Popup
            //     className="dashboard-table-popup"
            //     content="Download settlement recon report"
            //     position="bottom right"
            //     offset="10px"
            //     trigger={
            //       <span
            //         className="table-cta-item"
            //         onClick={openFileNameModal(rowData)}
            //       >
            //         <CustomIcon componentName="DOWNLOAD" />
            //       </span>
            //     }
            //   />
            // ),
            transactionAmount: () => (
              <span>
                {addCurrencySymbol(roundOffNumber(rowData.transactionAmount))}
              </span>
            ),
            adjustment: () => (
              <span>
                {addCurrencySymbol(roundOffNumber(rowData.adjustment))}
              </span>
            ),
            charges: () => (
              <span>{addCurrencySymbol(roundOffNumber(rowData.charges))}</span>
            ),
            settledAmount: () => (
              <span>
                {addCurrencySymbol(roundOffNumber(rowData.settledAmount))}
              </span>
            ),
          }));
          break;
        }
        case VENDOR: {
          const vendorData =
            pageData && pageData.content ? pageData.content : [];
          totalCount = vendorData.length;
          formattedData = vendorData.map(rowData => ({
            ...rowData,
            unFormattedData: rowData,
            id: rowData.payoutId,
            settlementTypeCTA: () => (
              <>
                <Conditional
                  if={
                    rowData.status === VENDOR_SETTLEMENT_STATUS_TYPES.PENDING ||
                    rowData.status === VENDOR_SETTLEMENT_STATUS_TYPES.CREATED
                  }
                >
                  <img
                    src={liveTag}
                    alt="live settlement"
                    className="live-tag-fixed"
                  />
                </Conditional>
                <Conditional if={rowData.settlementType === INSTANT_SETTLEMENT}>
                  <CustomIcon
                    componentName="LIGHTNING"
                    className="ml-2"
                    dimension="18px"
                  />
                </Conditional>
              </>
            ),
            addedOn: () => (
              <div className="flex ml-3">
                <span className="table-content">
                  {moment(rowData.addedOn).format('DD MMM YYYY,')}
                  <br />
                  {moment(rowData.addedOn).format('hh:mm A')}
                </span>
              </div>
            ),
            period: () => (
              <div className="flex">
                <span className="table-content">
                  {moment(rowData.periodStart).format('Do MMM YYYY, hh:mm A')} -{' '}
                  <br />
                  {moment(rowData.periodEnd).format('Do MMM YYYY, hh:mm A')}
                </span>
              </div>
            ),
            utr: () => (
              <div className="flex copy-to-clipboard-wrapper">
                <span className="table-content">{rowData.utr}</span>
                {rowData.utr && rowData.utr !== 'N/A' ? (
                  <CustomIcon
                    componentName="COPY_TO_CLIPBOARD"
                    handleClick={e => {
                      Analytics.track(
                        EVENTS.SETTLEMENTS[activeNavigation].UTR_COPIED,
                      );
                      copyToClipboard(rowData.utr)(e);
                    }}
                  />
                ) : (
                  PLACEHOLDER_TEXT
                )}
              </div>
            ),
            settlementStatus: () => (
              <span className={`${TX_STATUS_CLASSNAME[rowData.status] || ''}`}>
                {!(
                  (rowData.status === VENDOR_SETTLEMENT_STATUS_TYPES.FAILED ||
                    rowData.status ===
                      VENDOR_SETTLEMENT_STATUS_TYPES.REVERSED) &&
                  rowData.detailedFailureMessage
                ) ? (
                  getVenodorSettlementStatusTitle(rowData.status)
                ) : (
                  <Popup
                    content={rowData.detailedFailureMessage}
                    trigger={
                      <span>
                        {getVenodorSettlementStatusTitle(rowData.status)}
                        <span className="mr-left-4 small-svg">
                          <CustomIcon
                            componentName="INFO"
                            fill={
                              rowData.status ===
                                VENDOR_SETTLEMENT_STATUS_TYPES.REVERSED ||
                              rowData.status ===
                                VENDOR_SETTLEMENT_STATUS_TYPES.FAILED
                                ? 'var(--DANGER)'
                                : 'var(--SUCCESS_STATUS)'
                            }
                          />
                        </span>
                      </span>
                    }
                    position="bottom center"
                  />
                )}
                <Conditional
                  if={
                    rowData.status === VENDOR_SETTLEMENT_STATUS_TYPES.PENDING ||
                    rowData.status === VENDOR_SETTLEMENT_STATUS_TYPES.CREATED
                  }
                >
                  <Conditional if={liveSettlementState.loading}>
                    <div className="ui active mini inline loader mr-left-4" />
                  </Conditional>
                  <Conditional
                    if={
                      !liveSettlementState.loading &&
                      liveSettlementState.settlementList[rowData.payoutId]
                    }
                  >
                    <Conditional
                      if={
                        !liveSettlementState.settlementList[rowData.payoutId]
                          ?.estimatedTimetoArrival
                      }
                    >
                      <Text
                        variant="b12"
                        color="bodyLight"
                        className="font-normal mr-left-7 display-inline"
                      >
                        Expected Credit Time :{' '}
                        {formatDateToDateTimeFormat(
                          liveSettlementState.settlementList[rowData.payoutId]
                            ?.estimatedTimeToArrival,
                          TIME_FORMATS.DATE_MONTH_YEAR_WITH_TIME,
                        )}
                      </Text>
                    </Conditional>
                    <StepProgress
                      merchantLogo={merchantLogo}
                      settlementData={
                        liveSettlementState.settlementList[rowData.payoutId]
                      }
                    />
                  </Conditional>
                </Conditional>
              </span>
            ),
            settledAmount: () => (
              <span>
                {rowData.status === SETTLEMENT_STATUS_TYPES.SKIPPED
                  ? NOT_APPLICABLE
                  : addCurrencySymbol(
                      roundOffNumber(rowData.settledAmount),
                    ) /* eslint-disable-line prettier/prettier */}
                <Conditional
                  if={
                    rowData.settlementDetailedView?.settlementComponentsList
                      ?.length &&
                    ![
                      SETTLEMENT_STATUS_TYPES.FAILED,
                      SETTLEMENT_STATUS_TYPES.PENDING,
                      SETTLEMENT_STATUS_TYPES.SKIPPED,
                    ].includes(rowData.status)
                  }
                >
                  <div className="small-svg">
                    <Popup
                      trigger={
                        <span>
                          <Text
                            color="info"
                            variant="b12"
                            className="smart-recon-text small-text"
                          >
                            Smart recon{' '}
                          </Text>
                          <span>
                            <CustomIcon
                              componentName="INFO"
                              fill="var(--INFO)"
                            />
                          </span>
                        </span>
                      }
                      position="bottom center"
                      hoverable
                    >
                      <div className="pd-12 smart-recon-table">
                        {sortSettlementComponentsList(
                          rowData.settlementDetailedView
                            ?.settlementComponentsList,
                        ).map(breakDownDetails => {
                          const { event, eventType, amount } = breakDownDetails;
                          const label = getSmartReconEventLabel(event);

                          return (
                            <>
                              <Space
                                justifyContent="space-between"
                                alignItems="center"
                                key={event}
                                className="mr-top-12 mr-btm-12"
                              >
                                <Text
                                  color="bodyLight"
                                  variant="b12"
                                  className="font-normal"
                                >
                                  {label}
                                </Text>
                                <Text
                                  color={
                                    eventType === 'DEBIT' ? 'danger' : 'success'
                                  }
                                  variant="b14"
                                  strong
                                  className="font-normal"
                                >
                                  {addCurrencySymbol(roundOffNumber(amount))}
                                </Text>
                              </Space>
                              <hr />
                            </>
                          );
                        })}
                        <Text
                          variant="b12"
                          className="font-normal tiny-text line-ht-12"
                        >
                          Service charge and tax will be levied based on your
                          usage and plan type (postpaid/ prepaid). Check the{' '}
                          <Link
                            href={`${
                              location.pathname
                            }/settlement-details?settlementId=${
                              rowData.settlementId
                            }${env ? `&env=${env}` : ''}`}
                          >
                            {' '}
                            View Details
                          </Link>{' '}
                          section to know the detailed breakup.
                        </Text>
                      </div>
                    </Popup>
                  </div>
                </Conditional>
              </span>
            ),
          }));

          break;
        }
        default:
          formattedData = [...data];
      }

      let hasPrevEnabled = filters.pageNo !== 1;
      let hasNextEnabled = totalCount >= filters.pageSize;

      // updating pagination from the response
      if (
        activeNavigation === STANDARD &&
        data.length > 0 &&
        !isMerchantImportEnabled
      ) {
        hasPrevEnabled = !pagination.first;
        hasNextEnabled = !pagination.last;
      }

      updateTableData({
        totalCount,
        currentPageRowData: formattedData || [],
        hasPrevEnabled,
        hasNextEnabled,
        activeNavigation,
      });
    }
  }, [
    isLoading,
    data,
    liveSettlementState.loading,
    merchantLogo,
    settlementType,
    selectedTimeZone,
  ]);

  useEffect(() => {
    getSettlementsHolidays({ settlementType });
    getUpcomingHolidays({ settlementType });
  }, [settlementType]);

  useEffect(() => {
    getTableData(filters);
  }, [filters, activeNavigation, searchParams.get('env'), settlementType]);

  useEffect(() => {
    if (isOnDemandEligible) {
      getOnDemandSettlementAndFreeTrialStatus({
        cb: onDemandSettlementAndFreeTrialStatusCb,
      });
    }
  }, [isOnDemandEligible]);

  const onDemandSettlementAndFreeTrialStatusCb = (response = {}) => {
    const { OD = {}, FREE_TRIAL = {} } = response;
    const freeTrialActive = FREE_TRIAL.status === ACTIVE;

    let freeTrialTag = freeTrialActive || !OD;
    if (!freeTrialTag) {
      const ODStatus = getOnDemandStatus(OD);
      freeTrialTag = ODStatus === NOT_REQUESTED_ON_DEMAND;
    }
    if (freeTrialTag !== showFreeTrialTag) {
      setShowFreeTrialTag(freeTrialTag);
    }
  };

  const updateInstantSettlementConfig = response =>
    setInstantSettlementsConfig(response || {});

  const updateInstantSettlementsDailyLimit = response => {
    setInstantSettlementsDailyLimit(response || {});
    setISDailyLimitLoading(false);
  };

  const fetchStandardSettlementsPageData = () => {
    getOnDemandSettlementStatus({
      isModuleFederated,
      cb: response => {
        updateOnDemandStatus(response);
      },
      settlementType,
    });
    getInstantSettlementsRatesAndLimits({
      cb: response => updateInstantSettlementConfig(response),
      settlementType,
    });
    getInstantSettlementsEligibility({
      cb: response => {
        const displayISPitchBanner =
          response.eligibleStatus ===
          INSTANT_SETTLEMENTS_ELIGIBILITY_STATUS.ELIGIBLE;

        setInstantSettlementsStatus(response || {});
        if (
          response.updatedOn &&
          showInstantSettlementsStatusBanner(response.updatedOn)
        ) {
          setInstantSettlementsActivationAlertDisplay(
            !!response.registrationStatus,
          );
        }
        // add the conditions here on the basis of isSoftApproved and registrationStatus
        setInstantSettlementsPitchBannerDisplay(displayISPitchBanner);
      },
      settlementType,
    });
    setISDailyLimitLoading(true);
    getInstantSettlementsMaxDailyLimit({
      cb: updateInstantSettlementsDailyLimit,
      errorCb: () => setISDailyLimitLoading(false),
      settlementType,
    });
    resetUnsettledAmountLoader(true);
    getUnsettledAmount({
      cb: () => resetUnsettledAmountLoader(false),
      settlementType,
      isMerchantImportEnabled,
    });
    getNextSettlementsDetails({ settlementType });
  };

  useEffect(() => {
    if (activeNavigation === STANDARD) {
      fetchStandardSettlementsPageData();
    } else if (onDemandStatus) {
      // resetting the on demand values
      resetOnDemandStatus('');
    }
  }, [activeNavigation, searchParams.get('env'), settlementType]);

  const closeModal = () => {
    if (openModal === 'INSTANT_SETTLEMENTS_ACTIVATED')
      Analytics.track(
        EVENTS.SETTLEMENTS[INSTANT].CLOSE_CONFIRM_ACTIVATION_MODAL,
      );

    resetModal('');
  };

  useEffect(() => {
    if (holidaysData && Object.keys(holidaysData).length > 0) {
      const {
        isNormalMerchant,
        isHolidayEnabled,
        todayHoliday,
        cycle,
        nextWorkingDay,
        status,
      } = holidaysData;
      const nextDate = moment(nextWorkingDay).format('DD MMM YYYY');
      const isHold = status && status.toUpperCase() === HOLD;
      const merchantId = getItemFromLocalStorage('merchantId');
      if (isHold) {
        const message = () => (
          <span>
            Your settlements have been PUT ON HOLD. Contact{' '}
            <a
              target="_blank"
              href={`mailto:care@cashfree.com?subject=< MID: ${merchantId} > SETTLEMENTS ON HOLD  - Kindly help with next steps.`}
            >
              Care@Cashfree.com
            </a>{' '}
            to help us resolve it for you at the earliest.
          </span>
        );
        resetHolidaysAlert({
          settlementMessage: message,
        });
      } else if (!isNormalMerchant || cycle === 0) {
        if ((!isHolidayEnabled || isNormalMerchant) && todayHoliday) {
          resetHolidaysAlert({
            settlementMessage: `Today is a bank holiday. Settlements will resume on ${nextDate}.`,
          });
        } else {
          resetHolidaysAlert({});
        }
      } else {
        const settlementMessage = todayHoliday
          ? `Today is a bank holiday. Settlements will resume on ${nextDate}.`
          : `Funds will be settled within ${cycle} working ${
              cycle === 1 ? 'day' : 'days'
            } of the customer transaction.`; // eslint-disable-line
        resetHolidaysAlert({
          settlementMessage,
          knowMoreUrl: todayHoliday
            ? SETTLEMENT_HOLIDAY_URL
            : SETTLEMENT_NORMAL_DAY_URL,
        }); //eslint-disable-line
      }
      if (isHold || isNormalMerchant || !isHolidayEnabled) {
        resetSettlementHolidays(true);
      } else {
        resetSettlementHolidays(false);
      }
    }
  }, [holidaysData]);

  useEffect(() => {
    if (twoFactorAuthentication) {
      getTableData();
      resetTwoFactorAuthentication(false);
    }
    return () => {
      if (!isNavigatingToSettlementDetailsPage.current) {
        resetData();
      }
    };
  }, [twoFactorAuthentication]);

  const isOnDemand = activeNavigation === ON_DEMAND;

  const tableConfig = getTableConfig({
    page: IMPORT_TRANSACTIONS.SETTLEMENTS,
    isImportEnabled: isMerchantImportEnabled,
  });

  const getSettlementTableHeadings = () => {
    const headings = tableConfig?.[activeNavigation]?.TABLE_COLUMNS;

    return headings;
  };

  const headings = getSettlementTableHeadings() || [];
  const formattedColumns = formatColumns(headings);

  let FORMATTED_COLUMN_ID;

  if (pathname.includes('online') && activeNavigation === STANDARD) {
    FORMATTED_COLUMN_ID = formattedColumns.slice(1);
  } else if (activeNavigation === VENDOR) {
    FORMATTED_COLUMN_ID = formattedColumns.slice(0, -1);
  } else {
    FORMATTED_COLUMN_ID = formattedColumns;
  }

  if (isMerchantImportEnabled && Array.isArray(FORMATTED_COLUMN_ID)) {
    FORMATTED_COLUMN_ID = updateHeadersWithTimezone(
      FORMATTED_COLUMN_ID,
      selectedTimeZone,
    );
  }

  const noRecordsObj = {
    icon: <CustomIcon componentName="BOX" />,
    text: 'No results found',
  };

  const openInstantSettlements = () => {
    window.open(holidaysAlert.knowMoreUrl, '_blank');
    Analytics.track(
      `settlements_${ALERT_BAR_DATA.HOLIDAYS_ALERT.key}_know_more_click`,
    );
  };

  const AlertMarkup = () => (
    <div className="alert-text-settlements">
      {typeof holidaysAlert.settlementMessage === 'function'
        ? holidaysAlert.settlementMessage()
        : holidaysAlert.settlementMessage}{' '}
      {holidaysAlert.knowMoreUrl && (
        <span>
          <span style={{ fontFamily: 'dm-sans-medium' }}>
            Get your funds instantly.{' '}
          </span>
          <span
            className="text-primary w-600"
            onClick={openInstantSettlements}
            data-event-name="Link_KnowMore"
          >
            Know more
          </span>
        </span>
      )}
    </div>
  );

  const showSettlementAlertBar = () =>
    holidaysAlert.settlementMessage && showHolidaysAlertBar;

  const closeSettlementAlertBar = () => {
    setItemsInLocalStorage({
      [ALERT_BAR_DATA.HOLIDAYS_ALERT.localStorageKey]: false,
    });
    resetHolidaysAlertBar(false);
    Analytics.track(`settlements_${ALERT_BAR_DATA.HOLIDAYS_ALERT.key}_close`);
  };

  // update the on-demand status as per the api response
  const updateOnDemandStatus = response => {
    if (response && response.status)
      resetOnDemandStatus(
        ON_DEMAND_SETTLEMENT_STATUS_MAPPER[
          response.status.trim().toUpperCase()
        ],
      );
    else resetOnDemandStatus(NOT_REQUESTED);
  };

  const activateInstantSettlements = (values, setLoading) => {
    Analytics.track(EVENTS.SETTLEMENTS[INSTANT].CONFIRM_ACTIVATION);
    // make api call here
    requestInstantSettlementsOnboarding({
      payload: {
        channel: 'MERCHANT_DASHBOARD',
        registrationMetaRequests: {
          ...values,
        },
      },
      successCb: response => {
        // get the instant limits
        getInstantSettlementsMaxDailyLimit({
          cb: updateInstantSettlementsDailyLimit,
          errorCb: () => setISDailyLimitLoading(false),
        });
        getInstantSettlementsRatesAndLimits(updateInstantSettlementConfig);

        setInstantSettlementsPitchBannerDisplay(false);
        const { status } = response;
        if (status)
          setInstantSettlementsStatus({
            ...instantSettlementsStatus,
            registrationStatus: status,
          });
        setInstantSettlementsActivationAlertDisplay(true);
        resetModal('INSTANT_SETTLEMENTS_ACTIVATED');
      },
      errorCb: () => {
        setLoading(false);
      },
      settlementType,
    });
  };

  const closeISActivationBanner = () => {
    Analytics.track(EVENTS.SETTLEMENTS[INSTANT].HIDE_ACTIVATION_BANNER);
    setInstantSettlementsActivationAlertDisplay(false);
  };

  const showFAQModal = () => {
    Analytics.track(EVENTS.SETTLEMENTS[INSTANT].HAVE_ANY_QUESTIONS);
    resetModal('FAQ_MODAL');
  };

  const showISOnboardingModal = () => {
    const {
      ACTIVATE_INSTANTLY,
      ACTIVATE_INSTANTLY_FROM_FAQ_MODAL,
    } = EVENTS.SETTLEMENTS[INSTANT];
    Analytics.track(
      openModal === 'FAQ_MODAL'
        ? ACTIVATE_INSTANTLY_FROM_FAQ_MODAL
        : ACTIVATE_INSTANTLY,
    );
    resetModal('CONFIGURE_IS');
  };

  const handleRowClick = rowData => {
    if (activeNavigation === STANDARD)
      Analytics.track(
        EVENTS.SETTLEMENTS[activeNavigation].VIEW_SETTLEMENT_DETAILS,
      );
    setSettlementDetailsData(rowData.unFormattedData);
    isNavigatingToSettlementDetailsPage.current = true;

    if (isMerchantImportEnabled) {
      const {
        appliedFilters,
        pageNo,
        pageSize,
        includeSkipSettlements,
      } = filters;

      const formattedFilterObj = {
        ...appliedFilters,
        pageNo: pageNo - 1,
        pageSize,
        includeSkipSettlements: !!includeSkipSettlements,
      };

      const options = Object.keys(formattedFilterObj).reduce((acc, curr) => {
        const str = `${acc}&${curr}=${encodeURIComponent(
          formattedFilterObj[curr],
        )}`;
        return str;
      }, '');

      navigate(
        `${location.pathname}/settlement-details?settlementId=${
          rowData.id
        }&activeNavigation=${activeNavigation}${options}${
          env ? `&env=${env}` : ''
        }`,
      );
    } else {
      navigate(
        `${location.pathname}/settlement-details?settlementId=${
          rowData.id
        }&activeNavigation=${activeNavigation}${env ? `&env=${env}` : ''}`,
      );
    }
  };

  const navigationOptions = NAVIGATION_BAR_OPTIONS[menuSelected];

  // eslint-disable-next-line array-callback-return, consistent-return
  const updatedNavigationOptions = navigationOptions.filter(navigation => {
    const { key } = navigation;
    if (
      (key === 'on-demand' && isOnDemandEligible) ||
      (key === 'vendor' && easySplitEnabled)
    ) {
      return navigation;
    }
    if (key !== 'on-demand' && key !== 'vendor') {
      return navigation;
    }
  });

  const panes = updatedNavigationOptions.map(navigation => ({
    key: navigation.key,
    menuItem: navigation.text,
    render: () => null,
  }));

  const matchedParams = pathname.split('/').slice(-1)[0];

  let activePageIndex = panes.findIndex(ele => ele.key === matchedParams);
  activePageIndex = activePageIndex < 0 ? 0 : activePageIndex;

  const handleNavigationClick = (e, d) => {
    const { activeIndex, panes: pane } = d;
    const navigationObj = updatedNavigationOptions.find(
      option => option.text === pane[activeIndex].menuItem,
    );
    const pathNameArr = location.pathname.split('/');
    const hasNavigationKey = updatedNavigationOptions.find(
      navigation => navigation.key === pathNameArr[pathNameArr.length - 1],
    );

    if (navigationObj) {
      const navigateUrl = hasNavigationKey
        ? pathNameArr
            .toSpliced(pathNameArr.length - 1, 1, navigationObj.key)
            .join('/')
        : `${location.pathname}/${navigationObj.key}`;

      navigate(`${navigateUrl}${env ? `?env=${env}` : ''}`);
      setActiveNavigation(navigationObj?.text);
    }
  };

  if (
    !hasPermission &&
    !isModuleFederated &&
    (activeNavigation === STANDARD || activeNavigation === ON_DEMAND)
  ) {
    return (
      <WithReadPermissions
        description="to access Settlements page"
        merchantEmail={userDetails.merchantEmail}
      />
    );
  }

  // Use the onDemandStatus to handle the OD settlements APPROVED flow
  return (
    <div className="settlements">
      <Loader active={isLoading} />
      <Conditional if={!isMerchantImportEnabled}>
        <AnnouncementStrip
          data={ALERT_BAR_DATA}
          showAlertBar={showSettlementAlertBar}
          closeAlertBar={closeSettlementAlertBar}
          getAlertBarMarkup={() => <AlertMarkup />}
        />
      </Conditional>

      <Conditional if={eposActivated}>
        <Tab
          style={{ marginBottom: '28px' }}
          activeIndex={activePageIndex}
          panes={panes}
          menu={{ secondary: true, pointing: true }}
          onTabChange={handleNavigationClick}
        />
      </Conditional>
      <div
        className={`${
          activeNavigation === STANDARD ? 'settlements-standard-table' : ''
        }`}
      >
        {isOnDemand ? (
          <OnDemandSettlements
            setShowFreeTrialTag={setShowFreeTrialTag}
            settlementType={settlementType}
          />
        ) : (
          <>
            <Conditional if={activeNavigation === STANDARD}>
              <Conditional if={showInstantSettlementsActivationAlert}>
                <InstantSettlementsActivationBanner
                  onClose={closeISActivationBanner}
                  status={instantSettlementsStatus.registrationStatus}
                  isSoftApproved={instantSettlementsStatus.isSoftApproved}
                />
              </Conditional>
              <Conditional
                if={
                  showInstantSettlementsPitchBanner && !isMerchantImportEnabled
                }
              >
                <InstantSettlementsPitchPage
                  config={instantSettlementsConfig}
                  showFAQModal={showFAQModal}
                  onRequestActivation={showISOnboardingModal}
                  onDemandStatus={onDemandStatus}
                  autoActivationEligible={
                    instantSettlementsStatus?.autoActivationEligible || false
                  }
                />
              </Conditional>
              <Space wrap gap={2}>
                <UnsettledAmountCard
                  unSettledAmountLoader={unSettledAmountLoader}
                  unSettledAmountData={unSettledAmountData}
                  isDailyLimitLoading={isISDailyLimitLoading}
                  config={{
                    ...instantSettlementsDailyLimit,
                    ...instantSettlementsConfig,
                  }}
                  upcomingHolidays={upcomingHolidays}
                />
                <Conditional
                  if={
                    nextSettlementsDetails.status === ACTIVE &&
                    !isMerchantImportEnabled
                  }
                >
                  <NextSettlementsAmountCard
                    nextSettlementsDetails={nextSettlementsDetails}
                  />
                </Conditional>
              </Space>
            </Conditional>
            <div className="mt-3">
              <DashboardFilters
                menuSelected={menuSelected}
                filters={filters}
                filtersForDisplay={filtersForDisplay}
                activeNavigation={activeNavigation}
                getTableDataFn={getTableData}
                resetFilterFn={resetFilters}
                updateFilterFn={updateFilters}
                resetPageFn={resetPage}
              />
            </div>
            <Conditional if={activeNavigation === STANDARD}>
              <Space
                justifyContent="flex-end"
                gap={2}
                alignItems="center"
                className="mb-2"
              >
                <Toggle
                  active={!!filters.includeSkipSettlements}
                  onToggle={onSkipToggleChange}
                />
                Include Skipped Settlements
              </Space>
            </Conditional>

            <PaginatedTable
              data={currentPageRowData}
              tableHeading={FORMATTED_COLUMN_ID}
              emptyTableComponent={noRecordsObj}
              limit={filters.pageSize}
              limitOptions={DEFAULT_LIMIT_OPTIONS}
              hasPrev={hasPrev}
              hasNext={hasNext}
              currentPage={filters.pageNo}
              currentPageCount={currentPageRowData.length}
              totalCount={pagination.totalElements || 0}
              onPageChange={onPageChange}
              onLimitChange={onLimitChange}
              onRowClick={
                activeNavigation === STANDARD || activeNavigation === VENDOR
                  ? handleRowClick
                  : null
              }
              fetching={isLoading}
            />
          </>
        )}
      </div>
      <Conditional if={openModal === 'FAQ_MODAL'}>
        <FAQ_MODAL
          closeModal={closeModal}
          onRequestActivation={showISOnboardingModal}
        />
      </Conditional>
      <Conditional if={openModal === 'CONFIGURE_IS'}>
        <ConfigureInstantSettlements
          config={instantSettlementsConfig}
          onDemandStatus={onDemandStatus}
          closeModal={closeModal}
          confirmActivation={activateInstantSettlements}
          autoActivationEligible={
            instantSettlementsStatus?.autoActivationEligible || false
          }
        />
      </Conditional>
      <Conditional if={openModal === 'INSTANT_SETTLEMENTS_ACTIVATED'}>
        <InstantSettlementsActivationModal
          config={instantSettlementsConfig}
          closeModal={closeModal}
          onDemandStatus={onDemandStatus}
          registrationStatus={instantSettlementsStatus?.registrationStatus}
        />
      </Conditional>
    </div>
  );
}

Settlements.propTypes = {
  isModuleFederated: PropTypes.bool,
  settlements: PropTypes.object.isRequired,
  searchSettlements: PropTypes.func.isRequired,
  searchImportSettlements: PropTypes.func.isRequired,
  updateTableData: PropTypes.func.isRequired,
  updateFilters: PropTypes.func.isRequired,
  enableLoader: PropTypes.func.isRequired,
  resetPage: PropTypes.func,
  resetFilters: PropTypes.func,
  menuSelected: PropTypes.any,
  merchantDetails: PropTypes.any,
  twoFactorAuthentication: PropTypes.any,
  resetTwoFactorAuthentication: PropTypes.func,
  getSettlementsHolidays: PropTypes.func,
  resetSettlementHolidays: PropTypes.func,
  activeNavigation: PropTypes.string,
  resetData: PropTypes.func.isRequired,
  getUnsettledAmount: PropTypes.func.isRequired,
  getOnDemandSettlementStatus: PropTypes.func.isRequired,
  getInstantSettlementsEligibility: PropTypes.func.isRequired,
  requestInstantSettlementsOnboarding: PropTypes.func.isRequired,
  getInstantSettlementsMaxDailyLimit: PropTypes.func.isRequired,
  getInstantSettlementsRatesAndLimits: PropTypes.func.isRequired,
  getOnDemandSettlementAndFreeTrialStatus: PropTypes.func.isRequired,
  getSettlementTimeline: PropTypes.func.isRequired,
  setSettlementDetailsData: PropTypes.func.isRequired,
  resetSettlementType: PropTypes.func.isRequired,
  getNextSettlementsDetails: PropTypes.func.isRequired,
  getUpcomingHolidays: PropTypes.func.isRequired,
};

const mapStateToProps = createStructuredSelector({
  settlements: makeSelectSettlements(),
  twoFactorAuthentication: twoFactorAuthenticationSelector(),
  merchantDetails: selectMerchantDetailsSelector(),
});

function mapDispatchToProps(dispatch) {
  return {
    searchSettlements: data => dispatch(searchSettlementsAction(data)),
    searchImportSettlements: data =>
      dispatch(searchImportSettlementsAction(data)),
    enableLoader: () => dispatch(enableLoaderAction()),
    updateTableData: data => dispatch(updateTableDataAction(data)),
    updateFilters: data => dispatch(updateFiltersAction(data)),
    resetFilters: data => dispatch(resetFiltersAction(data)),
    generateSettlementReport: data =>
      dispatch(generateSettlementReportAction(data)),
    resetTwoFactorAuthentication: data =>
      dispatch(resetTwoFactorAuthenticationValue(data)),
    resetPage: data => dispatch(resetPageAction(data)),
    resetData: () => dispatch(resetDataAction()),
    getSettlementsHolidays: data =>
      dispatch(getSettlementsHolidaysAction(data)),
    getUnsettledAmount: data => dispatch(getUnsettledAmountAction(data)),
    getUnificationOnBoarding: data =>
      dispatch(getUnificationOnBoardingAction(data)),
    getInstantSettlementsEligibility: data =>
      dispatch(getInstantSettlementsEligibilityAction(data)),
    requestInstantSettlementsOnboarding: data =>
      dispatch(requestInstantSettlementsOnboardingAction(data)),
    getInstantSettlementsMaxDailyLimit: data =>
      dispatch(getInstantSettlementsMaxDailyLimitAction(data)),
    getInstantSettlementsRatesAndLimits: data =>
      dispatch(getInstantSettlementsRatesAndLimitsAction(data)),
    getOnDemandSettlementStatus: data =>
      dispatch(getOnDemandSettlementStatusAction(data)),
    getOnDemandSettlementAndFreeTrialStatus: data =>
      dispatch(getOnDemandSettlementAndFreeTrialStatusAction(data)),
    getSettlementTimeline: data => dispatch(getSettlementTimelineAction(data)),
    setSettlementDetailsData: data =>
      dispatch(setSettlementDetailsDataAction(data)),
    resetSettlementType: data => dispatch(resetSettlementTypeAction(data)),
    getNextSettlementsDetails: data =>
      dispatch(getNextSettlementsDetailsAction(data)),
    getUpcomingHolidays: data => dispatch(getUpcomingHolidaysAction(data)),
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export default compose(
  withConnect,
  memo,
)(Settlements);
